import { render } from "./sidebar.vue?vue&type=template&id=4c8ffd67&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=4c8ffd67&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4c8ffd67"

export default script